import ky, { HTTPError } from 'ky'
import { getAccessToken } from '@/shared/lib/auth-tokens'
import { refreshAuthTokens } from '@/shared/lib/refresh-auth-tokens'

const kyWithAuth = ky.create({
  prefixUrl: '/api/',
  credentials: 'include',
  referrerPolicy: 'origin-when-cross-origin',
  hooks: {
    beforeRequest: [
      (request) => {
        const accessToken = getAccessToken()
        if (!accessToken) return

        request.headers.set('Authorization', `Bearer ${accessToken}`)
      },
    ],
    beforeRetry: [
      async ({ request, error }) => {
        if (error instanceof HTTPError && error.response.status === 401) {
          const data = await refreshAuthTokens()
          request.headers.set('Authorization', `Bearer ${data.accessToken}`)
        }
      },
    ],
  },
  retry: {
    limit: 1,
    statusCodes: [401, 403, 500, 504],
  },
})

export { kyWithAuth as ky }
